



















import { Vue, Component, Prop, Emit } from 'vue-property-decorator';

@Component({

})
export default class SettingWrapper extends Vue {
  @Prop() hasFieldButton!: boolean

  @Prop({ type: Boolean,default: false }) disabled!: boolean

  @Emit()
  fieldButtonClick() {
    return null
  }

}
